import api from "api";

const dashboardStatistics = {
    getKpis: (params) => {
        return api().get('/dashboard/statistics/kpis', {
            params: { ...params }
        });
    },
    getEventos: (params) => {
        return api().get('/dashboard/statistics/eventos', {
            params: { ...params }
        });
    },
    getVendas: (params) => {
        return api().get('/dashboard/statistics/vendas', {
            params: { ...params }
        });
    },
    getIngressos: (params) => {
        return api().get('/dashboard/statistics/ingressos', {
            params: { ...params }
        });
    },
    getProdutos: (params) => {
        return api().get('/dashboard/statistics/produtos', {
            params: { ...params }
        });
    },
    getCupons: (params) => {
        return api().get('/dashboard/statistics/cupons', {
            params: { ...params }
        });
    },
    getDespesas: (params) => {
        return api().get('/dashboard/statistics/despesas', {
            params: { ...params }
        });
    },
}

export default dashboardStatistics;
